import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';

@Component({
  selector: 'cigna-cfb-submission-final-box',
  templateUrl: './submission-final-box.component.html',
  styleUrls: ['./submission-final-box.component.scss'],
})
export class SubmissionFinalBoxComponent implements OnInit {
  @Output() closeClicked = new EventEmitter();
  @Input() renderMode: string;

  constructor(
    public dialogRef: MatDialogRef<SubmissionFinalBoxComponent>,
    private appstateFacade: AppstateFacade,
  ) {}

  ngOnInit() {}

  onCloseClicked() {
    this.closeClicked.emit();
    this.appstateFacade.stashOnboardingInfo(true);
    this.dialogRef.close();
  }
}
